import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { UiSelectOption } from '../select/select.component';
import { UiMultiselectComponent } from './multiselect.component';

const MONTH_OPTIONS: UiSelectOption[] = [
  { id: 1,  label: 'Enero' },
  { id: 2,  label: 'Febrero' },
  { id: 3,  label: 'Marzo' },
  { id: 4,  label: 'Abril' },
  { id: 5,  label: 'Mayo' },
  { id: 6,  label: 'Junio' },
  { id: 7,  label: 'Julio' },
  { id: 8,  label: 'Agosto' },
  { id: 9,  label: 'Septiembre' },
  { id: 10, label: 'Octubre' },
  { id: 11, label: 'Noviembre' },
  { id: 12, label: 'Diciembre' },
];

/**
 * Variante de ui-multiselect pre-configurada para selección múltiple de mes.
 * Opciones fijas: Enero – Diciembre.
 * Uso: <ui-month-multiselect [(selected)]="selectedMonths" />
 */
@Component({
  selector: 'ui-month-multiselect',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiMultiselectComponent],
  template: `
    <ui-multiselect
      placeholder="Mes - Todos"
      [options]="monthOptions"
      [(selected)]="selected"
      [showLabel]="false"
      [showOptionalHint]="false"
      style="width: 250px"
    />
  `,
})
export class UiMonthMultiselectComponent {
  protected readonly monthOptions = MONTH_OPTIONS;
  readonly selected = model<UiSelectOption[]>([]);
}
